import { createFileRoute } from '@tanstack/react-router';

import { AttentionPage } from '@/features/operator/attention-page';

export const Route = createFileRoute('/_operator/')({ component: AttentionPage });
